// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSnippetsOutlinedSvg from "@fishx/icons-svg/es/asn/PSnippetsOutlined";
import FishxIcon from '../components/FishxIcon';

var PSnippetsOutlined = function PSnippetsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSnippetsOutlinedSvg
  }));
};

PSnippetsOutlined.displayName = 'PSnippetsOutlined';
export default React.forwardRef(PSnippetsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSnippetsOutlined.js
// module id = 3639
// module chunks = 0